(function () {
  'use strict';

  angular
    .module('vUuidMaskModule', [])
    .directive('vuuidmask', function () {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            element.attr('maxlength', 36);

            function formatUuid(value) {
              if (!value) return value;
              // Remove any non-hexadecimal characters (including dashes)
              let cleanedValue = value.replace(/[^0-9a-fA-F]/g, '').toLowerCase();

              if (cleanedValue.length > 8) {
                cleanedValue = cleanedValue.slice(0, 8) + '-' + cleanedValue.slice(8);
              }
              if (cleanedValue.length > 13) {
                cleanedValue = cleanedValue.slice(0, 13) + '-' + cleanedValue.slice(13);
              }
              if (cleanedValue.length > 18) {
                cleanedValue = cleanedValue.slice(0, 18) + '-' + cleanedValue.slice(18);
              }
              if (cleanedValue.length > 23) {
                cleanedValue = cleanedValue.slice(0, 23) + '-' + cleanedValue.slice(23);
              }

              return cleanedValue;
            }

            function validateUuid(value) {
              if (!value) {
                ngModel.$setValidity('uuid', true);
                return value;
              }
              const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
                  valid = UUID_REGEX.test(value);
              ngModel.$setValidity('uuid', valid);
              return valid ? value : undefined;
            }

            ngModel.$parsers.push((value) => {
              const formattedValue = formatUuid(value);
              ngModel.$setViewValue(formattedValue);
              ngModel.$render();
              return validateUuid(formattedValue);
            });

            ngModel.$formatters.push((value) => {
              return formatUuid(value);
            });

            element.on('blur keyup change', () => {
              const formattedValue = formatUuid(element.val());
              ngModel.$setViewValue(formattedValue);
              ngModel.$render();
              scope.$apply();
            });
            
        }
      }
    });
}());
